"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link"; 

import "../../../CommanComponents/OurRecentWork/OurRecentWork.css";
import AnimatedCount from "./CountUp/AnimatedCount";

export const BlockchainOurRecentWorkJSON = ({ content, path }) => {
    const backgroundStyle = {
        backgroundImage:
            "linear-gradient(98.46deg, #410EAD -1.13%, #7B3FE4 98.96%)",
    };
    const boxShadow = {
        boxShadow: "0px 0px 28px 0px rgba(151, 151, 151, 0.16)",
    };

    return (
        <>
            <div className="container mx-auto my-10 lg:my-[110px] px-4 md:px-24 lg:px-24 xl:px-0">
                <h2 className="text-2xl md:text-3xl xl:text-4xl font-bold text-center font-manrope">
                    {content?.title}
                </h2>
                <div className="grid grid-cols-1 xl:grid-cols-3 md:grid-cols-2 gap-10 justify-center md:mt-20 mt-14">
                    {content?.services?.map((ele, index) => {
                        return (
                            <div key={index} className="flex flex-col">
                                <Link href={ele?.imageLink && ele?.imageLink}>
                                    <div
                                        className="flex flex-col justify-between bg-[#F8F3FF] rounded-2xl imageHover relative overflow-hidden min-h-[550px] max-h-[550px] group"
                                        style={{
                                            boxShadow:
                                                "0px 0px 38px 0px #BABABA29",
                                        }}
                                    >
                                        <div className="flex-grow">
                                            <Image
                                                src={`${`/assets/${path}/${ele?.logo}`}.webp`}
                                                alt={ele?.logo}
                                                width={100}
                                                height={100}
                                                className="mx-auto py-6 px-5 w-72 h-24 cursor-pointer text-center object-contain"
                                            />
                                            <div className="flex flex-col gap-5 my-3 xl:px-6 lg:px-5 md:px-3 px-2 justify-center text-black items-center">
                                                <span className="text-2xl text-center font-extrabold leading-7">
                                                    {ele?.textTitle}
                                                </span>
                                                <p className="text-base text-center font-medium leading-5">
                                                    {ele?.text}
                                                </p>
                                            </div>
                                        </div>
                                        <Image
                                            src={`${`/assets/${path}/${ele?.image}`}.webp`}
                                            alt={ele?.image}
                                            width={300}
                                            height={250}
                                            className="mx-auto object-contain cursor-pointer text-end md:pl-4 pl-0 pt-9 w-fit h-[300px] absolute bottom-0 right-0"
                                        />

                                        <div className="absolute bottom-4 right-4 bg-[#7338DD] p-4 rounded-full flex items-center justify-center rotate-[140deg]">
                                            <div className="arrow"></div>
                                        </div>
                                    </div>
                                </Link>

                                {/* Sub-description Container */}
                                <div
                                    className="grid gap-2 place-items-center font-bold py-9 lg:py-12 rounded-xl mt-4 h-44 flex-grow"
                                    style={{
                                        ...boxShadow,
                                        background:
                                            ele?.subDesColor === "bg-linear"
                                                ? backgroundStyle.backgroundImage
                                                : "#FFFFFF",
                                    }}
                                >
                                    {ele?.descriptionNumber && (
                                        <span className="text-2xl font-bold md:text-3xl xl:text-4xl">
                                            <AnimatedCount end={parseInt(ele?.descriptionNumber)} suffix="+" />

                                        </span>
                                    )}

                                    {ele?.descriptionText && (
                                        <span className="text-lg md:text-xl xl:text-2xl text-white">
                                            {ele?.descriptionText}
                                        </span>
                                    )}

                                    {ele?.subDescription && (
                                        <span className="text-xl font-semibold leading-6 text-[#323232]">
                                            {ele?.subDescription}
                                        </span>
                                    )}

                                    {ele?.viewMore && (
                                        <Link
                                            href={
                                                ele?.viewMoreLink &&
                                                ele?.viewMoreLink
                                            }
                                        >
                                            <p className="text-base font-medium leading-4 text-[#410EAD] hover:text-[#0BB226] cursor-pointer">
                                                {ele?.viewMore}
                                            </p>
                                        </Link>
                                    )}

                                    {ele?.btnName && (
                                        <Link
                                            href={ele?.btnLink && ele?.btnLink}
                                        >
                                            <button className="text-lg font-semibold leading-5 border border-white text-white rounded-md py-1.5 px-8 bg-transparent hover:bg-[#0BB226] hover:text-black transition delay-150 ease-in-out duration-300">
                                                {ele?.btnName}
                                            </button>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default BlockchainOurRecentWorkJSON;
